import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import AgenciesDS from "../../DataServices/AgenciesDs";
import { useCustomContext } from "../CustomComponents/CustomComponents";
import { insertLog } from "../Logs/InsertLog";
import { PutObjectCommand, S3Client } from "@aws-sdk/client-s3";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";



const AddAgencyLogic = () => {

    const agenciesDS = new AgenciesDS();
    const useremail = localStorage.getItem("email");
    const userName = useremail?.split("@")[0];

    const [agencyEditId, setagencyEditId] = useState('');
    const [datasets, setDatasets] = useState([]);
    const [agencie, setAgencie] = useState({});
    const [openSection, setOpenSection] = useState(["primary"]);
    const [file, setFile] = useState(null);
    const [fileBase64, setFileBase64] = useState("");
    const [filePreview, setFilePreview] = useState("");
    const [hasExistingFile, setHasExistingFile] = useState(false);

    const [jsonInput, setJsonInput] = useState("");
    const [jsonError, setJsonError] = useState(false);
    const { showAlert, stopHudRotation, hud, showToast } = useCustomContext();
    const [selectedDataset, setSelectedDataset] = useState(null);
    const [priority, setPriority] = useState("");

    const [errors, setErrors] = useState({});
    // const [snailEmailErrors, setSnailEmailErrors] = useState([""]);
    // const [dropoffEmailErrors, setDropoffEmailErrors] = useState([""])
    // const [faxErrors, setFaxErros] = useState([""]);
    // const [emailReqErrors, setEmailReqErrors] = useState([""])

    const [mongoId, setMongoId] = useState(null);

    // Primary Details
    const [agencyID, setAgencyID] = useState("");
    const [agencyName, setAgencyName] = useState("");
    const [datasetID, setDatasetID] = useState("");
    const [agencyDisplayID, setAgencyDisplayID] = useState("");
    const [agencyDisplayName, setAgencyDisplayName] = useState("");
    const [agencyCountyName, setAgencyCountyName] = useState("");
    const [agencyPhoneNumbers, setAgencyPhoneNumbers] = useState([{ number: "", isPrimary: true }]);
    const [agencyContactPerson, setAgencyContactPerson] = useState("");
    const [agencyDepartment, setAgencyDepartment] = useState("");
    const [handledBy, setHandledBy] = useState("");
    const [handledByUser, setHandledByUser] = useState("");
    const [handledByUserEmail, setHandledByUserEmail] = useState("");
    const [isActive, setIsActive] = useState(true);
    const [docketType, setDocketType] = useState("");
    const [dataSiteUrl, setDataSiteUrl] = useState("");
    const [seqNo, setSeqNo] = useState("");
    const [skipCount, setSkipCount] = useState("0");
    const [seqList, setSeqList] = useState([
        { year: new Date().getFullYear().toString(), seqNo: "0" }
    ]);

    // Address fields
    // const [addressName, setAddressName] = useState("");
    const [addressLine, setAddressLine] = useState("");
    const [city, setCity] = useState("");
    const [stateVal, setStateVal] = useState("");
    const [zip, setZip] = useState("");

    // SMTP
    const [smtpSubject, setSmtpSubject] = useState("");

    const [isDirty, setIsDirty] = useState(false);
    const markDirty = () => setIsDirty(true);

    const [isCloneMode, setIsCloneMode] = useState(false);

    const [datasetS3Key, setDatasetS3Key] = useState("");
    const [pdfOption, setPdfOption] = useState("universal");
    const globalFormDataRef = useRef({ s3Key: "", acroFields: {} });
    const customFormCacheRef = useRef({ file: null, filePreview: null, jsonInput: "", acroFieldsList: [] });
    const universalFormCacheRef = useRef({ jsonInput: "", acroFieldsList: [] });
    const [isJsonEditable, setIsJsonEditable] = useState(false);

    const navigate = useNavigate();
    const toggleSection = (section) => {
        setOpenSection((prev) => {
            if (prev.includes(section)) {
                return prev.filter((item) => item !== section);
            }
            return [...prev, section];
        });
    };

    // Associated emails
    const [emails, setEmails] = useState([""]);

    const addEmail = () => setEmails([...emails, ""]);

    const removeEmail = (index) => {
        const updated = [...emails];
        updated.splice(index, 1);
        setEmails(updated);
    };

    const updateEmail = (index, value) => {
        const updated = [...emails];
        updated[index] = value;
        setEmails(updated);
    };

    const addSeq = () => {
        const currentYear = new Date().getFullYear().toString();
        setSeqList([...seqList, { year: currentYear, seqNo: "0" }]);
        markDirty();
    };


    const removeSeq = (index) => {

        showAlert(
            "Are you sure you want to Delete?",
            [
                {
                    label: "Yes",
                    onClick: () => {
                        const updated = seqList.filter((_, i) => i !== index);
                        setSeqList(updated);
                        markDirty();
                    },
                    color: "var(--buttonColor)"
                },
                {
                    label: "No",
                    onClick: () => { },
                    color: "red",
                }
            ]
        );
    };

    const updateSeq = (index, field, value) => {
        const updated = [...seqList];
        updated[index][field] = value; // keep it as string
        setSeqList(updated);
        markDirty();
    };


    const handleBack = () => {
        if (!isDirty) {
            navigate("/Agencies");
            return;
        }

        showAlert(
            "You have unsaved changes. Are you sure you want to leave?",
            [
                {
                    label: "Cancel",
                    onClick: () => { },
                    color: "#999",
                },
                {
                    label: "Leave",
                    onClick: () => {
                        setIsDirty(false);
                        navigate("/Agencies");
                    },
                    color: "red",
                },
            ]
        );
    };

    const handleJsonInput = (value) => {
        setJsonInput(value);
        try {
            JSON.parse(value);
            setJsonError(false);
        } catch {
            setJsonError(true);
        }
    };




    // const handleSaveFile = async () => {
    //     if (!file) return;

    //     try {
    //         const base64 = await convertFileToBase64(file);
    //         setFileBase64(base64); 
    //         console.log("File saved as Base64:", base64);
    //         console.log("File name:", file.name);
    //     } catch (error) {
    //         console.error("Error converting file to Base64:", error);
    //     }
    // };


    const handleClearFile = () => {
        setFile(null);
        setFileBase64("");
        setFilePreview("");
        setHasExistingFile(false);     // <-- important
        markDirty();
        const el = document.getElementById("fileUploadInput");
        if (el) el.value = null;
    };

    useEffect(() => {
        if (!datasetID || datasets.length === 0) return;

        const selected = datasets.find(ds => ds.datasetID === datasetID);
        setSelectedDataset(selected);

    }, [datasetID, datasets]);


    useEffect(() => {
        // Browser refresh/close warning
        const handleBeforeUnload = (e) => {
            if (isDirty) {
                e.preventDefault();
                e.returnValue = "";
            }
        };

        // Navigation link interception
        const handleNavigation = (e) => {
            if (!isDirty) return;

            const link = e.target.closest('a');
            if (link) {
                const href = link.getAttribute('href');
                // Check if it's an internal navigation link
                if (href && (href.startsWith('/') || href.startsWith('#'))) {
                    e.preventDefault();
                    e.stopPropagation();

                    showAlert(
                        "You have unsaved changes. Are you sure you want to leave?",
                        [
                            {
                                label: "Cancel",
                                onClick: () => { },
                                color: "#999",
                            },
                            {
                                label: "Leave",
                                onClick: () => {
                                    setIsDirty(false);
                                    setTimeout(() => navigate(href), 0);
                                },
                                color: "red",
                            },
                        ]
                    );
                }
            }
        };

        // Add both event listeners
        window.addEventListener("beforeunload", handleBeforeUnload);
        document.addEventListener('click', handleNavigation, true);

        // Cleanup both listeners
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
            document.removeEventListener('click', handleNavigation, true);
        };
    }, [isDirty, navigate]);


    useEffect(() => {
        const id = localStorage.getItem("id");
        const cloneId = localStorage.getItem("cloneId");
        const cloneMode = localStorage.getItem("isClone") === "true";

        setIsCloneMode(cloneMode);

        // Step 1: Show HUD immediately

        if (id || cloneId) {
            hud("Please Wait...");
            // Step 2: Delay the heavy operations to next event loop
            setTimeout(() => {
                fetchDatasets();

                fetchAgencieswithId(id || cloneId).finally(() => {
                    stopHudRotation();
                });

            }, 50);
        }  // even 0 is enough, but 50ms is smoother
        else {
            fetchDatasets();
        }
    }, []);


    const fetchAgencieswithId = async (id) => {
        try {
            const req = { id };
            const response = await agenciesDS.AP_Agency_ById_GET(req);
            const data = response.data;
            console.log('data', data);
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;

            if (data.statusCode === 200 && body.record) {

                setAgencie(body.record);

                if (!isCloneMode && body.record._id) {
                    localStorage.setItem("mongoId", body.record._id);
                    setMongoId(body.record._id);
                } else {
                    setMongoId(null);
                }

                // patchFormValues(body.record);
                const clonedRecord = { ...body.record };

                if (isCloneMode) {
                    clonedRecord.id = undefined;
                    clonedRecord._id = undefined;
                }

                patchFormValues(clonedRecord);
            }
            else {
                showAlert(body?.message || "Failed to load Agencies.", [{ label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }]);
                insertLog(
                    `${userName} failed to fetch agency details for Agency ID ${id}`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    id || '',
                    'GET',
                    'AP_Agency_ById_GET',
                    'FAILED',
                    'Failed to load agency details'
                );
            }
        } catch (err) {
            showAlert(err.message || "Something went wrong while fetching Agencies.", [{ label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }]);
            insertLog(
                `${userName} failed to fetch agency details for Agency ID ${id}`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                id || '',
                'GET',
                'AP_Agency_ById_GET',
                'FAILED',
                err.message || 'Error loading agency details'
            );
        }
    };

    const fetchDatasets = async () => {
        try {
            const req = { limit: 100, offset: 0 };
            const response = await agenciesDS.AP_Dataset_List_GET(req);

            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;
            if (data.statusCode === 200 && Array.isArray(body.records)) {

                // const allowedDatasets = JSON.parse(localStorage.getItem('winterSoldierDatasets') || '[]');
                // const filteredDatasets = body.records.filter(record =>
                //   allowedDatasets.includes(record.datasetID) 
                // );
                const accessLevel = localStorage.getItem('accessLevel');
                const isAdmin = accessLevel === '1' || accessLevel === 'Admin';
                const allowedDatasets = JSON.parse(localStorage.getItem('winterSoldierDatasets') || '[]');

                const filteredDatasets = isAdmin
                    ? body.records
                    : body.records.filter(record => allowedDatasets.includes(record.datasetID));
                setDatasets(filteredDatasets);
            }
            else {
                showAlert(body?.message || "Failed to load Datasets.", [{ label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }]);
                insertLog(
                    `${userName} failed to fetch datasets`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    '',
                    'GET',
                    'AP_Dataset_List_GET',
                    'FAILED',
                    'Failed to load datasets'
                );
            }
        } catch (err) {
            showAlert(err.message || "Something went wrong while fetching Datasets.", [{ label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }]);
            insertLog(
                `${userName} failed to fetch datasets`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                '',
                'GET',
                'AP_Dataset_List_GET',
                'FAILED',
                err.message || 'Error loading datasets'
            );
        }
    };

    const convertFileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file); // reads file as base64
            reader.onload = () => {
                // Remove the data:*/*;base64, prefix
                const base64String = reader.result.split(',')[1];
                resolve(base64String);
            };
            reader.onerror = (error) => reject(error);
        });
    };


    const entryType = selectedDataset?.entryType;

    const isRequestBased = entryType === "Request Based PDF Entry";
    const isCounterBased = entryType === "Counter Based WebSite Entry";
    const isDateRangeBased = entryType === "Date Range Based PDF Entry";



    // AcroFields List View States
    const [acroFieldsTab, setAcroFieldsTab] = useState("json");
    const [acroFieldsList, setAcroFieldsList] = useState([]);
    const syncAcroJsonToList = () => {
        try {
            if (!jsonInput || jsonInput.trim() === "") {
                setAcroFieldsList([]);
                setJsonError(false);
                return;
            }

            const parsed = JSON.parse(jsonInput);

            if (typeof parsed === 'object' && !Array.isArray(parsed)) {
                const list = Object.entries(parsed).map(([key, value]) => ({
                    key,
                    value: String(value),
                    _isNew: false
                }));
                setAcroFieldsList(list);
            } else {
                setAcroFieldsList([]);
            }

            setJsonError(false);
        } catch (error) {
            console.error("Error syncing JSON to list:", error);
            setJsonError(true);
        }
    };
    const syncAcroListToJson = () => {
        if (!acroFieldsList || acroFieldsList.length === 0) {
            setJsonInput("");
            return "";
        }

        try {
            const obj = {};

            acroFieldsList.forEach(item => {
                if (item.key && item.key.trim()) {
                    obj[item.key] = item.value || "";
                }
            });

            let jsonString = "";
            if (Object.keys(obj).length > 0) {
                jsonString = JSON.stringify(obj, null, 2);
                setJsonInput(jsonString);
            } else {
                setJsonInput("");
            }

            setJsonError(false);
            return jsonString;
        } catch (error) {
            console.error("Error syncing list to JSON:", error);
            setJsonError(true);
            return "";
        }
    };

    const handleDeleteAcroField = (index) => {
        const updated = [...acroFieldsList];
        updated.splice(index, 1);
        setAcroFieldsList(updated);
        markDirty();
    };

    const handleUniversalPdfClick = async () => {
        setPdfOption("universal");
        setIsDirty(true);

        customFormCacheRef.current = {
            file,
            filePreview,
            jsonInput,
            acroFieldsList
        };
        const { s3Key, acroFields } = globalFormDataRef.current;

        if (s3Key) {
            setDatasetS3Key(s3Key);
            if (universalFormCacheRef.current.jsonInput !== "") {
                setJsonInput(universalFormCacheRef.current.jsonInput);
                setAcroFieldsList(universalFormCacheRef.current.acroFieldsList);
            } else {
                // First time loading universal — use API data
                setJsonInput(JSON.stringify(acroFields, null, 2));
                setAcroFieldsList(
                    Object.entries(acroFields).map(([key, value]) => ({
                        key,
                        value: String(value),
                        _isNew: false
                    }))
                );
            }
        } else {
            fetchdatasetS3Key();
        }

        setErrors(prev => ({
            ...prev,
            fileUpload: ""
        }));
    };

    const handleCustomPdfClick = () => {
        setPdfOption("custom");
        setIsDirty(true);

        universalFormCacheRef.current = {
            jsonInput,
            acroFieldsList
        };

        if (customFormCacheRef.current.file || customFormCacheRef.current.jsonInput !== "") {
            setFile(customFormCacheRef.current.file);
            setFilePreview(customFormCacheRef.current.filePreview);
            setJsonInput(customFormCacheRef.current.jsonInput);
            setAcroFieldsList(customFormCacheRef.current.acroFieldsList);
            setHasExistingFile(false);
        } else {
            setDatasetS3Key("");
            setFile(null);
            setFilePreview(null);
            setHasExistingFile(false);
            setJsonInput("");
            setAcroFieldsList([]);
        }

        setErrors(prev => ({ ...prev, fileUpload: "" }));
    };

    const createAgencyObject = async (jsonString = jsonInput, s3Key = "") => {
        const safeTrim = (val) => (typeof val === "string" ? val.trim() : "");

        if (isCounterBased) {
            return {
                id: mongoId || undefined,
                agencyID: safeTrim(agencyID),
                agencyName: safeTrim(agencyName),
                datasetID: safeTrim(datasetID),
                agencyDisplayID: safeTrim(agencyDisplayID),
                agencyDisplayName: safeTrim(agencyDisplayName),
                agencyCountyName: safeTrim(agencyCountyName),
                dataSiteUrl: safeTrim(dataSiteUrl),
                docketType: safeTrim(docketType),
                handledByUser: safeTrim(handledByUser),
                // handledByUserEmail: safeTrim(handledByUserEmail),
                priority,
                isActive,
                seqDetails: seqList.map(item => ({
                    year: parseInt(item.year),
                    seqNo: parseInt(item.seqNo)
                })),
                consecutiveSkipCount: parseInt(skipCount)
            };
        }
        if (isDateRangeBased) {
            return {
                id: mongoId || undefined,
                agencyID: safeTrim(agencyID),
                agencyName: safeTrim(agencyName),
                datasetID: safeTrim(datasetID),
                agencyDisplayID: safeTrim(agencyDisplayID),
                agencyDisplayName: safeTrim(agencyDisplayName),
                agencyCountyName: safeTrim(agencyCountyName),
                dataSiteUrl: safeTrim(dataSiteUrl),
                docketType: safeTrim(docketType),
                handledByUser: safeTrim(handledByUser),
                priority,
                isActive,
                reqRange: {
                    offsetBegins: parseInt(dateRange.from),
                    offsetEnds: parseInt(dateRange.to)
                }
            };
        }

        const requestTypeMap = {
            fax: "Fax",
            emailReq: "Email",
            snail: "Snail Mail",
            dropoff: "Drop Off",
            agenweb: "Request On Agency Website",
            crashdocx: "Crash Docs"
        };
        const requestType = requestTypeMap[reqMethod] || "";

        // ------ RESPONSE TYPE ------
        const responseTypeMap = {
            fax: "Fax",
            email: "Email",
            pickup: "Pick Up",
            snailmail: "Snail Mail",
            agenweb: "Request On Agency Website",
            crashdocs: "Crash Docs"
        };
        const responseType = responseTypeMap[responseMethod] || "";

        const frequencySettingsObj = { time };
        if (selectedWeekDays.length) frequencySettingsObj.weekDays = selectedWeekDays;
        if (selectedMonthDays.length) frequencySettingsObj.monthDays = selectedMonthDays;

        const frequencyObject = {
            frequencyType,
            frequencySettings: frequencySettingsObj
        };

        let processedAcroFields = {};

        try {
            if (jsonString && jsonString.trim() !== "") {
                processedAcroFields = await processAcroFields(JSON.parse(jsonString));
            }
        } catch (err) {
            // ✅ Print actual error message clearly
            console.error("processAcroFields failed:", err.message);
            throw new Error(err.message || "Failed to process acroFields");
        }
        /* ======================================
           TRIGGER EVENTS
        ====================================== */
        const triggerEventsObject = triggerEvents.map(t => ({
            waitDays: t.waitDays,
            action: t.action
        }));

        const reqRange = {
            offsetBegins: parseInt(dateRange.from),
            offsetEnds: parseInt(dateRange.to)
        }

        const requestMethodObj = { requestType };
        switch (reqMethod) {
            case "fax":
                requestMethodObj.faxSettings = faxList;
                break;
            case "emailReq":
                requestMethodObj.emailSettings = emailList;
                break;
            case "dropoff":
                requestMethodObj.dropoffSettings = {
                    emailaddress: dropOffEmails,
                    address: {
                        name: safeTrim(dropName),
                        address: safeTrim(dropAddress),
                        city: safeTrim(dropCity),
                        state: safeTrim(dropState),
                        zip: safeTrim(dropZip)

                    }
                };
                break;
            case "snail":
                requestMethodObj.snailMailSettings = {
                    emailaddress: snailEmailList,
                    address: {
                        name: snailName.trim(),
                        address: snailAddress.trim(),
                        city: snailCity.trim(),
                        state: snailState.trim(),
                        zip: snailZip.trim(),
                    }
                };
                break;
            case "agenweb":
                requestMethodObj.agencyWebsiteSettings = {
                    email: agenEmail.trim(),
                    websiteURL: agenUrl.trim(),
                    description: agenDescription.trim()
                };
                break;
            case "crashdocx":
                requestMethodObj.crashDocsWebsiteSettings = {
                    email: crashEmail.trim(),
                    websiteURL: crashUrl.trim(),
                    description: crashDescription.trim()
                };
                break;
        }
        const responseMethodObj = { responseType };

        // switch (responseMethod) {
        //     case "fax":
        //         responseMethodObj.faxSettings = resFaxList
        //         break;

        //     case "email":
        //         responseMethodObj.emailSettings = resEmailList;
        //         break;

        //     case "snailmail":
        //         responseMethodObj.snailMailSettings = {
        //             emailaddress: resSnailEmailList,
        //             address: {
        //                 name: safeTrim(resSnailName),
        //                 address: safeTrim(resSnailAddress),
        //                 city: safeTrim(resSnailCity),
        //                 state: safeTrim(resSnailState),
        //                 zip: safeTrim(resSnailZip),

        //             }
        //         };
        //         break;

        //     case "pickup":
        //         responseMethodObj.pickupSettings = {
        //             emailaddress: resPickupEmails,
        //             address: {
        //                 name: resPickupName.trim(),
        //                 address: resPickupAddress.trim(),
        //                 city: resPickupCity.trim(),
        //                 state: resPickupState.trim(),
        //                 zip: resPickupZip.trim(),
        //             }
        //         };
        //         break;

        //     case "agenweb":
        //         responseMethodObj.agencyWebsiteSettings = {
        //             email: resAgenEmail.trim(),
        //             websiteURL: resAgenUrl.trim(),
        //             description: resAgenDescription.trim()
        //         };
        //         break;

        //     case "crashdocs":
        //         responseMethodObj.crashDocsWebsiteSettings = {
        //             email: resCrashEmail.trim(),
        //             websiteURL: resCrashUrl.trim(),
        //             description: resCrashDescription.trim()
        //         };
        //         break;
        // }
        return {
            id: mongoId || undefined,
            agencyID: safeTrim(agencyID),
            datasetID: safeTrim(datasetID),
            agencyName: safeTrim(agencyName),
            agencyDisplayID: safeTrim(agencyDisplayID),
            agencyDisplayName: safeTrim(agencyDisplayName),
            agencyCountyName: safeTrim(agencyCountyName),
            agencyPhoneNumbers: agencyPhoneNumbers,
            agencyAddress: {
                address: safeTrim(addressLine),
                city: safeTrim(city),
                state: safeTrim(stateVal),
                zip: safeTrim(zip),
            },
            agencyContactPerson: safeTrim(agencyContactPerson),
            agencyDepartment: safeTrim(agencyDepartment),
            Handledby: safeTrim(handledBy),
            handledByUser: safeTrim(handledByUser),
            handledByUserEmail: safeTrim(handledByUserEmail),
            isActive,
            smtpSettings: {
                subject: safeTrim(smtpSubject),
            },


            pdfForm: {
                // fileData: fileBase64,
                s3Key: s3Key,
                fileName: s3Key ? s3Key.split("/").pop() : "",
                universalForm: pdfOption === "universal" && datasetS3Key?.trim() !== "",
                acroFields: processedAcroFields
            },

            associatedFromEMails: emails,

            requestMethod: requestMethodObj,
            responseMethod: responseMethodObj,
            frequency: frequencyObject,

            TriggerEvents: triggerEventsObject,
            callAndMailSettings: {
                waitDaysBeforeSendingAnotherEmail:
                    waitDaysBeforeSendingEmail === "" ? null : Number(waitDaysBeforeSendingEmail),
                waitDaysBeforeCallingAgain:
                    waitDaysBeforeCallingAgain === "" ? null : Number(waitDaysBeforeCallingAgain),
            },

            reqRange: reqRange
        };



    };

    //request-response method
    const [reqMethod, setReqMethod] = useState('');


    // MULTIPLE VALUE LISTS
    const [faxList, setFaxList] = useState([""]);
    const [emailList, setEmailList] = useState([""]);
    const [snailEmailList, setSnailEmailList] = useState([""]);
    const [dropOffEmails, setDropOffEmails] = useState([""]);
    const [reqMethodValues, setReqMethodValues] = useState({
        fax: { faxList: [""] },
        emailReq: { emailList: [""] },
        snail: { snailEmailList: [""], snailName: "", snailAddress: "", snailCity: "", snailState: "", snailZip: "" },
        dropoff: { dropOffEmails: [""], dropName: "", dropAddress: "", dropCity: "", dropState: "", dropZip: "" },
        agenweb: { agenEmail: "", agenUrl: "", agenDescription: "" },
        crashdocx: { crashEmail: "", crashUrl: "", crashDescription: "" }
    });


    // ADD & REMOVE FUNCTIONS
    const addFax = () => { setFaxList([...faxList, ""]); markDirty(); };
    const removeFax = (i) => { setFaxList(faxList.filter((_, index) => index !== i)); markDirty(); };

    const addEmailReq = () => { setEmailList([...emailList, ""]); markDirty(); };
    const emailRemove = (i) => { setEmailList(emailList.filter((_, index) => index !== i)); markDirty(); };

    const addSnailEmail = () => { setSnailEmailList([...snailEmailList, ""]); markDirty(); };
    const removeSnailEmail = (i) => { setSnailEmailList(snailEmailList.filter((_, index) => index !== i)); markDirty(); };

    const addDropoffEmail = () => { setDropOffEmails([...dropOffEmails, ""]); markDirty(); };
    const removeDropoffEmail = (i) => { setDropOffEmails(dropOffEmails.filter((_, index) => index !== i)); markDirty(); };

    // --------------------------
    // SNAIL MAIL FIELDS
    // --------------------------
    const [snailName, setSnailName] = useState("");
    const [snailAddress, setSnailAddress] = useState("");
    const [snailState, setSnailState] = useState("");
    const [snailCity, setSnailCity] = useState("");
    const [snailZip, setSnailZip] = useState("");

    // --------------------------
    // DROP OFF FIELDS
    // --------------------------
    const [dropName, setDropName] = useState("");
    const [dropAddress, setDropAddress] = useState("");
    const [dropState, setDropState] = useState("");
    const [dropCity, setDropCity] = useState("");
    const [dropZip, setDropZip] = useState("");

    // AGENCY WEBSITE FIELDS
    const [agenEmail, setAgenEmail] = useState("");
    const [agenUrl, setAgenUrl] = useState("");
    const [agenDescription, setAgenDescription] = useState("");

    const [crashEmail, setcrashEmail] = useState("");
    const [crashUrl, setcrashUrl] = useState("");
    const [crashDescription, setcrashDescription] = useState("");

    // RESPONSE METHOD
    const [responseMethod, setResponseMethod] = useState("");
    const [resEmailList, setResEmailList] = useState([""]);
    const [resFaxList, setResFaxList] = useState([""]);
    const [resSnailEmailList, setResSnailEmailList] = useState([""]);
    const [resSnailName, setResSnailName] = useState("");
    const [resSnailAddress, setResSnailAddress] = useState("");
    const [resSnailCity, setResSnailCity] = useState("");
    const [resSnailState, setResSnailState] = useState("");
    const [resSnailZip, setResSnailZip] = useState("");
    const [resPickupEmails, setResPickupEmails] = useState([""]);
    const [resPickupName, setResPickupName] = useState("");
    const [resPickupAddress, setResPickupAddress] = useState("");
    const [resPickupCity, setResPickupCity] = useState("");
    const [resPickupState, setResPickupState] = useState("");
    const [resPickupZip, setResPickupZip] = useState("");
    const [resAgenEmail, setResAgenEmail] = useState("");
    const [resAgenUrl, setResAgenUrl] = useState("");
    const [resAgenDescription, setResAgenDescription] = useState("");
    const [resCrashEmail, setResCrashEmail] = useState("");
    const [resCrashUrl, setResCrashUrl] = useState("");
    const [resCrashDescription, setResCrashDescription] = useState("");
    const [responseMethodValues, setResponseMethodValues] = useState({
        fax: {
            resFaxList,
        },
        email: {
            resEmailList,
        },
        snailmail: {
            resSnailEmailList,
            resSnailName,
            resSnailAddress,
            resSnailCity,
            resSnailState,
            resSnailZip
        },
        pickup: {
            resPickupEmails,
            resPickupName,
            resPickupAddress,
            resPickupCity,
            resPickupState,
            resPickupZip
        },
        agenweb: {
            resAgenEmail,
            resAgenUrl,
            resAgenDescription,
        },
        crashdocs: {
            resCrashEmail,
            resCrashUrl,
            resCrashDescription,
        }
    });

    const addResFax = () => { setResFaxList(prev => [...prev, ""]); markDirty(); };
    const removeResFax = (index) => { setResFaxList(prev => prev.filter((_, i) => i !== index)); markDirty(); };

    const addResEmail = () => { setResEmailList(prev => [...prev, ""]); markDirty(); };
    const removeResEmail = (index) => { setResEmailList(prev => prev.filter((_, i) => i !== index)); markDirty(); };
    const addResSnailEmail = () => { setResSnailEmailList(prev => [...prev, ""]); markDirty(); };
    const removeResSnailEmail = (index) => { setResSnailEmailList(prev => prev.filter((_, i) => i !== index)); markDirty(); };
    const addResPickupEmail = () => { setResPickupEmails(prev => [...prev, ""]); markDirty(); };
    const removeResPickupEmail = (index) => { setResPickupEmails(prev => prev.filter((_, i) => i !== index)); markDirty(); };


    // WAIT DAYS
    const [triggerEvents, setTriggerEvents] = useState([
        { waitDays: "", action: "" }
    ]);
    const [waitDaysBeforeSendingEmail, setWaitDaysBeforeSendingEmail] = useState("");
    const [waitDaysBeforeCallingAgain, setWaitDaysBeforeCallingAgain] = useState("");


    // --------------------------
    // FREQUENCY
    // --------------------------
    const [frequencyType, setFrequencyType] = useState(""); // Weekly/Monthly/OddWeekly/EvenWeekly
    const [selectedWeekDays, setSelectedWeekDays] = useState([]);
    const [selectedMonthDays, setSelectedMonthDays] = useState([]);
    const [showMonthDropdown, setShowMonthDropdown] = useState(false);
    const [time, setTime] = useState('');
    const [patchedWeekly, setPatchedWeekly] = useState([]);
    const [patchedOddWeekly, setPatchedOddWeekly] = useState([]);
    const [patchedEvenWeekly, setPatchedEvenWeekly] = useState([]);
    const [patchedMonthDays, setPatchedMonthDays] = useState([]);

    const weekdays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    const monthDays = Array.from({ length: 31 }, (_, i) => i + 1);

    const toggleWeekDay = (day) => {
        setSelectedWeekDays((prev) =>
            prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
        );
    };

    const toggleMonthDay = (day) => {
        setSelectedMonthDays((prev) =>
            prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
        );
        markDirty();

    };


    // DATE RANGE
    const [dateRange, setDateRange] = useState({
        from: null,
        to: null
    });

    const handleReqMethodChange = (method) => {
        setReqMethod(method);
        clearFieldError("reqMethodError");
        setIsDirty(true);

        if (method !== "fax") setFaxList([]);
        if (method !== "emailReq") setEmailList([]);
        if (method !== "snail") {
            setSnailEmailList([]);
            // setSnailEmailErrors([]);
            setSnailName("");
            setSnailAddress("");
            setSnailCity("");
            setSnailState("");
            setSnailZip("");
        }
        if (method !== "dropoff") {
            setDropOffEmails([]);
            // setDropoffEmailErrors([]);
            setDropName("");
            setDropAddress("");
            setDropCity("");
            setDropState("");
            setDropZip("");
        }
    };


    useEffect(() => {
        if (!reqMethod) return;

        const data = reqMethodValues[reqMethod];
        if (!data) return;

        switch (reqMethod) {
            case "fax":
                setFaxList(data.faxList || [""]);
                break;
            case "emailReq":
                setEmailList(data.emailList || [""]);
                break;
            case "snail":
                setSnailEmailList(data.snailEmailList || [""]);
                setSnailName(data.snailName || "");
                setSnailAddress(data.snailAddress || "");
                setSnailCity(data.snailCity || "");
                setSnailState(data.snailState || "");
                setSnailZip(data.snailZip || "");
                break;
            case "dropoff":
                setDropOffEmails(data.dropOffEmails || [""]);
                setDropName(data.dropName || "");
                setDropAddress(data.dropAddress || "");
                setDropCity(data.dropCity || "");
                setDropState(data.dropState || "");
                setDropZip(data.dropZip || "");
                break;
            case "agenweb":
                setAgenEmail(data.agenEmail || "");
                setAgenUrl(data.agenUrl || "");
                setAgenDescription(data.agenDescription || "");
                break;
            case "crashdocx":
                setcrashEmail(data.crashEmail || "");
                setcrashUrl(data.crashUrl || "");
                setcrashDescription(data.crashDescription || "");
                break;
            default:
                break;
        }
    }, [reqMethod, reqMethodValues]);
    useEffect(() => {
        if (!responseMethod) return;

        const data = responseMethodValues[responseMethod];
        if (!data) return;

        switch (responseMethod) {

            case "fax":
                setResFaxList(data.resFaxList || [""]);
                break;

            case "email":
                setResEmailList(data.resEmailList || [""]);
                break;

            case "snailmail":
                setResSnailEmailList(data.resSnailEmailList || [""]);
                setResSnailName(data.resSnailName || "");
                setResSnailAddress(data.resSnailAddress || "");
                setResSnailCity(data.resSnailCity || "");
                setResSnailState(data.resSnailState || "");
                setResSnailZip(data.resSnailZip || "");
                break;

            case "pickup":
                setResPickupEmails(data.resPickupEmails || [""]);
                setResPickupName(data.resPickupName || "");
                setResPickupAddress(data.resPickupAddress || "");
                setResPickupCity(data.resPickupCity || "");
                setResPickupState(data.resPickupState || "");
                setResPickupZip(data.resPickupZip || "");
                break;

            case "agenweb":
                setResAgenEmail(data.resAgenEmail || "");
                setResAgenUrl(data.resAgenUrl || "");
                setResAgenDescription(data.resAgenDescription || "");
                break;

            case "crashdocs":
                setResCrashEmail(data.resCrashEmail || "");
                setResCrashUrl(data.resCrashUrl || "");
                setResCrashDescription(data.resCrashDescription || "");
                break;

            default:
                break;
        }
    }, [responseMethod, responseMethodValues]);

    const handleResMethodChange = (method) => {
        setResponseMethod(method);
        markDirty();
        // SAME as request version
        clearFieldError("responseMethodError");    // SAME as request version

        // fax
        if (method !== "fax") setResFaxList([]);

        // email
        if (method !== "email") setResEmailList([]);

        // snail mail
        if (method !== "snailmail") {
            setResSnailEmailList([]);
            setResSnailName("");
            setResSnailAddress("");
            setResSnailCity("");
            setResSnailState("");
            setResSnailZip("");
        }

        // pickup
        if (method !== "pickup") {
            setResPickupEmails([]);
            setResPickupName("");
            setResPickupAddress("");
            setResPickupCity("");
            setResPickupState("");
            setResPickupZip("");
        }

        // agency website
        if (method !== "agenweb") {
            setResAgenEmail("");
            setResAgenUrl("");
            setResAgenDescription("");
        }

        // crashdocs
        if (method !== "crashdocs") {
            setResCrashEmail("");
            setResCrashUrl("");
            setResCrashDescription("");
        }
    };

    const validateFields = () => {
        let newErrors = {};

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const numberRegex = /^[0-9]+$/;
        const alphaRegex = /^[A-Za-z\s]+$/;
        const zipRegex = /^[0-9]{5,6}$/;

        /* ======================================================
           REQUIRED FIELDS
        ====================================================== */
        if (!String(agencyID).trim())
            newErrors.agencyID = "AgencyID is Required";

        const phoneNumberValues = agencyPhoneNumbers.map(p => p.number.trim()).filter(n => n !== "");
        const duplicatePhones = phoneNumberValues.filter(
            (num, index) => phoneNumberValues.indexOf(num) !== index
        );

        if (!agencyName || agencyName.trim() === "") newErrors.agencyName = "Agency Name is Required";
        if (!datasetID || datasetID.trim() === "") newErrors.datasetID = "Dataset ID is Required";

        if (!agencyDisplayName) newErrors.agencyDisplayName = "Agency display Name is Required";
        if (!agencyCountyName) newErrors.agencyCountyName = "Agency County Name is Required";
        // Address validations
        // if (!addressName) newErrors.addressName = "Name is required";

        // if (!addressLine) newErrors.addressLine = "Address is Required";

        if (!agencyDisplayID || agencyDisplayID.trim() === "") {
            newErrors.agencyDisplayID = "Agency Display ID is required";
        }

        // if (!city) newErrors.city = "City Name is Required";
        // else if (!alphaRegex.test(city)) newErrors.city = "Only letters allowed";

        // if (!stateVal) newErrors.stateVal = "Sate Name is Required";
        // else if (!alphaRegex.test(stateVal)) newErrors.stateVal = "Only letters allowed";

        // if (!zip) newErrors.zip = "Zip Code is Required";
        // else if (!zipRegex.test(zip)) newErrors.zip = "Enter valid ZIP (5–6 digits)";

        // if (!agencyPhoneNumber || agencyPhoneNumber.trim() === "") {
        //     newErrors.agencyPhoneNumber = "Person phone number is required";
        // } else if (!/^[0-9]+$/.test(agencyPhoneNumber)) {
        //     newErrors.agencyPhoneNumber = "Only digits are allowed";
        // }

        // if (!agencyContactPerson) newErrors.agencyContactPerson = "Agency Contact Person name is Required";
        // if (!agencyDepartment) newErrors.agencyDepartment = "Agency Department is Required";
        // if (!handledBy) newErrors.handledBy = "select option";
        // SMTP Subject Validation


        //==========================
        // JSON VALIDATION
        // ==========================
        // Only validate if updating (mongoId exists)

        if (entryType === "Counter Based WebSite Entry") {

            // if (!dataSiteUrl.trim()) newErrors.dataSiteUrl = "Data Site URL is required";
            if (!skipCount.toString().trim()) newErrors.skipCount = "Consecutive Skip Count is required";

            // seqList.forEach((item, index) => {
            //     if (!item.year ) {
            //       newErrors[`seqYear${index}`] = "Please enter Year.";
            //     } else if (!/^\d{4}$/.test(item.year)) {
            //       newErrors[`seqYear${index}`] = "Year must be 4 digits.";
            //     }

            //     if (!item.seqNo ) {
            //       newErrors[`seqNo${index}`] = "Please enter Sequence Number.";
            //     } else if (!/^\d+$/.test(item.seqNo)) {
            //       newErrors[`seqNo${index}`] = "Sequence Number must be numeric.";
            //     }
            //   });
            setErrors(newErrors);
            return newErrors;
        }
        if (entryType === "Date Range Based PDF Entry") {
            if (dateRange.from === "" || dateRange.from === null) {
                newErrors.FromError = "Please enter a valid start range.";
            } else if (Number(dateRange.from) >= 0) {
                newErrors.FromError = "Start range must be a negative number.";
            }

            if (dateRange.to === "" || dateRange.to === null) {
                newErrors.ToError = "Please enter a valid end range.";
            } else if (Number(dateRange.to) > 0) {
                newErrors.ToError = "End range must be zero or a negative number.";
            }

            setErrors(newErrors);
            return newErrors;
        }

        else {

            // Validate each phone entry is not empty
            agencyPhoneNumbers.forEach((phone, index) => {
                if (!phone.number || phone.number.trim() === "") {
                    newErrors[`phone_${index}`] = "Phone number cannot be empty.";
                }
            });
            // if (mongoId && !isCloneMode) {
            //     if (!jsonInput || jsonInput.trim() === "") {
            //         newErrors.jsonInput = "JSON object is required";
            //     } else if (jsonError) {
            //         newErrors.jsonInput = "Invalid JSON";
            //     }
            // } else {
            //     // For new records, only validate if JSON is provided
            //     if (jsonInput && jsonInput.trim() !== "" && jsonError) {
            //         newErrors.jsonInput = "Invalid JSON";
            //     }
            // }

            // PDF Upload Validation
            // Only validate if updating (mongoId exists)
            // PDF Upload Validation

            if (jsonInput && jsonInput.trim()) {
                try {
                    const parsed = JSON.parse(jsonInput);

                    if (typeof parsed !== "object" || Array.isArray(parsed)) {
                        newErrors.jsonInput = "AcroFields must be a valid JSON object";
                    }
                } catch {
                    newErrors.jsonInput = "Invalid JSON";
                }
            }

            if (mongoId && !isCloneMode) {

                if (pdfOption === "universal") {

                    if (!datasetS3Key) {
                        newErrors.fileUpload = "Universal PDF is not available";
                    }

                } else {

                    if (!file && !hasExistingFile) {
                        newErrors.fileUpload = "PDF file is required";
                    }
                    else if (file && file.type && file.type !== "application/pdf") {
                        newErrors.fileUpload = "Only PDF files are allowed";
                    }

                }
            }
            else {

                if (pdfOption === "custom") {

                    if (file && file.type && file.type !== "application/pdf") {
                        newErrors.fileUpload = "Only PDF files are allowed";
                    }

                }
            }


            /* ======================================================
               VALIDATE ASSOCIATED EMAILS
            ====================================================== */
            emails.forEach((email, index) => {
                if (!email) {
                    newErrors[`email_${index}`] = "Email is required";
                } else if (!emailRegex.test(email)) {
                    newErrors[`email_${index}`] = "Invalid email format";
                }
            });




            if (reqMethod === "fax") {
                faxList.forEach((fax, index) => {
                    if (!fax || fax.trim() === "") {
                        newErrors[`fax_${index}`] = "Fax number is required";
                    }
                });
            }


            if (reqMethod === "emailReq") {
                emailList.forEach((email, index) => {
                    if (!email || email.trim() === "") {
                        newErrors[`emailReq_${index}`] = "Email is required";
                    }
                    else if (!emailRegex.test(email.trim())) {
                        newErrors[`emailReq_${index}`] = "Invalid email format";
                    }
                });

            }

            if (reqMethod === "snail") {
                if (!snailEmailList.length) {
                    newErrors.snailEmail_0 = "Email is required";
                } else {
                    snailEmailList.forEach((email, index) => {
                        const cleanedEmail = email?.trim() || "";

                        if (!cleanedEmail) {
                            newErrors[`snailEmail_${index}`] = "Email is required";
                        }
                        else if (!emailRegex.test(cleanedEmail)) {
                            newErrors[`snailEmail_${index}`] = "Invalid email format";
                        }
                    });
                }
                if (!snailName.trim()) newErrors.snailName = "Name is required.";
                if (!snailAddress.trim()) newErrors.snailAddress = "Address is required.";
                if (!snailCity.trim()) newErrors.snailCity = "City is required.";
                if (!snailState.trim()) newErrors.snailState = "State is required.";
                if (!snailZip.trim()) newErrors.snailZip = "ZIP code is required.";
            }
            if (reqMethod === "dropoff") {

                dropOffEmails.forEach((email, index) => {
                    const cleanedEmail = email?.trim() || "";

                    if (!cleanedEmail) {
                        newErrors[`dropOffEmail_${index}`] = "Email is required";
                    } else if (!emailRegex.test(cleanedEmail)) {
                        newErrors[`dropOffEmail_${index}`] = "Invalid email format";
                    }
                });
                if (!dropName.trim()) newErrors.dropName = "Contact name is required.";
                if (!dropAddress.trim()) newErrors.dropAddress = "Address is required.";
                if (!dropCity.trim()) newErrors.dropCity = "City is required.";
                if (!dropState.trim()) newErrors.dropState = "State is required.";
                if (!dropZip.trim()) newErrors.dropZip = "ZIP code is required.";
            }
            if (reqMethod === "agenweb") {
                const cleanedEmail = agenEmail?.trim() || "";

                if (!cleanedEmail) {
                    newErrors.agenEmail = "Email is required.";
                } else if (!emailRegex.test(cleanedEmail)) {
                    newErrors.agenEmail = "Invalid email format.";
                }
                if (!agenUrl.trim()) newErrors.agenUrl = "Website URL is required.";
                if (!agenDescription.trim()) newErrors.agenDescription = "Descrption is required.";

            }
            if (reqMethod === "crashdocx") {
                const cleanedEmail = crashEmail?.trim() || "";

                if (!cleanedEmail) {
                    newErrors.crashEmail = "Email is required.";
                } else if (!emailRegex.test(cleanedEmail)) {
                    newErrors.crashEmail = "Invalid email format.";
                }
                if (!crashUrl.trim()) newErrors.crashUrl = "Website URL is required.";
                if (!crashDescription.trim()) newErrors.crashDescription = "Descrption is required.";
            }

            /* ======================================================
                RESPONSE METHOD VALIDATION
             ====================================================== */

            if (!responseMethod) {
                newErrors.responseMethodError = "Please select a response method.";
            }

            // if (responseMethod === "fax") {
            //     if (!resFaxList.length) {
            //         newErrors.resFax_0 = "Fax number is required";
            //     } else {
            //         resFaxList.forEach((fax, index) => {
            //             if (!fax || fax.trim() === "") {
            //                 newErrors[`resFax_${index}`] = "Fax number is required";
            //             }
            //         });
            //     }
            // }

            // if (responseMethod === "email") {
            //     resEmailList.forEach((email, index) => {
            //         const cleaned = email?.trim() || "";
            //         if (!cleaned) {
            //             newErrors[`resEmail_${index}`] = "Email is required";
            //         } else if (!emailRegex.test(cleaned)) {
            //             newErrors[`resEmail_${index}`] = "Invalid email format";
            //         }
            //     });
            // }

            // if (responseMethod === "snailmail") {
            //     if (!resSnailEmailList.length) {
            //         newErrors.resSnailEmail_0 = "Email is required";
            //     } else {
            //         resSnailEmailList.forEach((email, index) => {
            //             const cleaned = email?.trim() || "";
            //             if (!cleaned) {
            //                 newErrors[`resSnailEmail_${index}`] = "Email is required";
            //             } else if (!emailRegex.test(cleaned)) {
            //                 newErrors[`resSnailEmail_${index}`] = "Invalid email format";
            //             }
            //         });
            //     }

            //     // Remaining fields
            //     if (!resSnailName.trim()) newErrors.resSnailName = "Name is required.";
            //     if (!resSnailAddress.trim()) newErrors.resSnailAddress = "Address is required.";
            //     if (!resSnailCity.trim()) newErrors.resSnailCity = "City is required.";
            //     if (!resSnailState.trim()) newErrors.resSnailState = "State is required.";
            //     if (!resSnailZip.trim()) newErrors.resSnailZip = "ZIP code is required.";
            // }

            // if (responseMethod === "pickup") {
            //     resPickupEmails.forEach((email, index) => {
            //         const cleaned = email?.trim() || "";
            //         if (!cleaned) {
            //             newErrors[`resPickupEmail_${index}`] = "Email is required";
            //         } else if (!emailRegex.test(cleaned)) {
            //             newErrors[`resPickupEmail_${index}`] = "Invalid email format";
            //         }
            //     });

            //     if (!resPickupName.trim()) newErrors.resPickupName = "Contact name is required.";
            //     if (!resPickupAddress.trim()) newErrors.resPickupAddress = "Address is required.";
            //     if (!resPickupCity.trim()) newErrors.resPickupCity = "City is required.";
            //     if (!resPickupState.trim()) newErrors.resPickupState = "State is required.";
            //     if (!resPickupZip.trim()) newErrors.resPickupZip = "ZIP code is required.";
            // }

            // if (responseMethod === "agenweb") {
            //     const cleaned = resAgenEmail?.trim() || "";

            //     if (!cleaned) {
            //         newErrors.resAgenEmail = "Email is required.";
            //     } else if (!emailRegex.test(cleaned)) {
            //         newErrors.resAgenEmail = "Invalid email format.";
            //     }

            //     if (!resAgenUrl.trim()) newErrors.resAgenUrl = "Website URL is required.";
            //     if (!resAgenDescription.trim()) newErrors.resAgenDescription = "Description is required.";
            // }

            // if (responseMethod === "crashdocs") {
            //     const cleaned = resCrashEmail?.trim() || "";

            //     if (!cleaned) {
            //         newErrors.resCrashEmail = "Email is required.";
            //     } else if (!emailRegex.test(cleaned)) {
            //         newErrors.resCrashEmail = "Invalid email format.";
            //     }

            //     if (!resCrashUrl.trim()) newErrors.resCrashUrl = "Website URL is required.";
            //     if (!resCrashDescription.trim()) newErrors.resCrashDescription = "Description is required.";
            // }

            if (!reqMethod) {
                newErrors.reqMethodError = "Please select a request method.";
            }
            if (
                !waitDaysBeforeSendingEmail ||
                !Number.isInteger(Number(waitDaysBeforeSendingEmail)) ||
                Number(waitDaysBeforeSendingEmail) <= 0
            ) {
                newErrors.waitDaysBeforeSendingEmail = "Please enter a number greater than 0.";
            }
            if (
                !waitDaysBeforeCallingAgain ||
                !Number.isInteger(Number(waitDaysBeforeCallingAgain)) ||
                Number(waitDaysBeforeCallingAgain) <= 0
            ) {
                newErrors.waitDaysBeforeCallingAgain = "Please enter a number greater than 0.";
            }

            // Date Range Validation
            if (dateRange.from === "" || dateRange.from === null) {
                newErrors.FromError = "Please enter a valid start range.";
            } else if (Number(dateRange.from) > 0) {
                newErrors.FromError = "Start range must be a 0 or negative number.";
            }

            // TO: 0 or negative numbers
            if (dateRange.to === "" || dateRange.to === null) {
                newErrors.ToError = "Please enter a valid end range.";
            } else if (Number(dateRange.to) > 0) {
                newErrors.ToError = "End range must be zero or a negative number.";
            }
            // Trigger Events Validation
            triggerEvents.forEach((t, index) => {

                // Validate waitDays
                if (t.waitDays === "" || Number(t.waitDays) < 1) {
                    newErrors[`waitDaysError_${index}`] = "Please enter a number greater than 0 days.";
                }
                // Validate action
                if (!t.action || t.action.trim() === "") {
                    newErrors[`actionError_${index}`] = "Please select an action.";
                }

            });
            if (!frequencyType) {
                newErrors.frequency = "Please select a frequency type.";
            }
            // 2. Weekly / OddWeekly / EvenWeekly → Week days required
            if (["Weekly", "OddWeekly", "EvenWeekly"].includes(frequencyType)) {
                if (selectedWeekDays.length === 0) {
                    newErrors.frequency = "Please select at least one weekday.";
                }
            }
            // 3. Monthly → Month days required
            if (frequencyType === "Monthly" && selectedMonthDays.length === 0) {
                newErrors.frequency = "Please select at least one monthly day.";
            }
            if (!time || time === "") {
                newErrors.time = "Please select a valid time.";
            }

            setErrors(newErrors);

            return newErrors;
        }
    };

    const sectionErrorMap = {
        primary: [
            "agencyID",
            "agencyName",
            "datasetID",
            "agencyDisplayName",
            "agencyCountyName",
            "addressLine",
            "city",
            "stateVal",
            "zip",
            "agencyContactPerson",
            "agencyDepartment",
            "handledBy",
            "handledByUser",
            "isActive"
        ],

        emails: key => key.startsWith("email_"),

        fileSection: ["fileUpload", "jsonInput"],

        // 🔥 EVERYTHING BELOW OPENS "request"
        request: [
            // ----- Request Method -----
            "reqMethod",
            "fax",
            "faxList",
            "emailList",
            "snailEmailList",
            "snailName",
            "snailAddress",
            "snailCity",
            "snailState",
            "snailZip",
            "dropOffEmails",
            "dropName",
            "dropAddress",
            "dropCity",
            "dropState",
            "dropZip",
            "agenEmail",
            "agenUrl",
            "agenDescription",
            "crashEmail",
            "crashUrl",
            "crashDescription",

            // ----- Response Method -----
            "responseMethod",
            "resFaxList",
            "resEmailList",
            "resSnailEmailList",
            "resSnailName",
            "resSnailAddress",
            "resSnailCity",
            "resSnailState",
            "resSnailZip",
            "resPickupEmails",
            "resPickupName",
            "resPickupAddress",
            "resPickupCity",
            "resPickupState",
            "resPickupZip",
            "resAgenEmail",
            "resAgenUrl",
            "resAgenDescription",
            "resCrashEmail",
            "resCrashUrl",
            "resCrashDescription",

            // ----- Frequency -----
            "frequency",
            "frequencyType",
            "time",
            "weekDays",
            "monthDays",

            // ----- Date Range -----
            "FromError",
            "ToError",

            // ----- Trigger Events -----
            "triggerEvents"
        ],
        callMailSettings: [
            "waitDaysBeforeSendingEmail",
            "waitDaysBeforeCallingAgain"
        ]
    };
    const openErrorSections = (errorsObj) => {
        const errorKeys = Object.keys(errorsObj);

        // 1️⃣ PRIMARY
        if (sectionErrorMap.primary.some(k => errorsObj[k])) {
            setOpenSection(["primary"]);
            return;
        }

        // 2️⃣ PHONE NUMBERS
        if (errorsObj.duplicatePhone || Object.keys(errorsObj).some(k => k.startsWith("phone_"))) {
            setOpenSection(["agencyPhoneNumbers"]);
            return;
        }

        // 3️⃣ EMAILS
        if (errorKeys.some(k => k.startsWith("email_"))) {
            setOpenSection(["emails"]);
            return;
        }

        // 4️⃣ FILE
        if (sectionErrorMap.fileSection.some(k => errorsObj[k])) {
            setOpenSection(["fileSection"]);
            return;
        }

        // 5️⃣ REQUEST (Request + Response + Trigger + Frequency + Date Range)
        if (
            sectionErrorMap.request.some(k => errorsObj[k]) ||
            errorKeys.some(
                k =>
                    k.startsWith("fax_") ||
                    k.startsWith("emailReq_") ||
                    k.startsWith("snailEmail_") ||
                    k.startsWith("dropOffEmail_") ||
                    k.startsWith("resFax_") ||
                    k.startsWith("resEmail_") ||
                    k.startsWith("resSnailEmail_") ||
                    k.startsWith("resPickupEmail_") ||
                    k.startsWith("waitDaysError_") ||
                    k.startsWith("actionError_")
            )
        ) {
            setOpenSection(["request"]);
            return;
        }

        // 6️⃣ CALL MAIL SETTINGS
        if (sectionErrorMap.callMailSettings.some(k => errorsObj[k])) {
            setOpenSection(["callMailSettings"]);
        }
    };




    const handleFinalSave = async () => {
        if (mongoId && !isDirty) {
            showAlert("No modifications have been identified.", [
                { label: "Ok", onClick: () => { }, color: "var(--buttonColor)" }
            ]);
            return;
        }

        let currentJsonString = jsonInput;

        if (acroFieldsTab === "json") {
            syncAcroJsonToList();
            currentJsonString = jsonInput;
        } else if (acroFieldsTab === "list") {
            currentJsonString = syncAcroListToJson();
        }

        const errorsObj = validateFields();

        console.log(" Validation result", errorsObj);
        if (Object.keys(errorsObj).length > 0) {
            openErrorSections(errorsObj);
            stopHudRotation();
            return;
        }
        showAlert(
            mongoId && !isCloneMode
                ? "Are you sure? Please confirm the details before you update."
                : "Are you sure? Please confirm the details before you save.",
            [
                {
                    label: "Cancel",
                    onClick: () => { },
                    color: "#999",
                },
                {
                    label: mongoId && !isCloneMode ? "Update" : "Save",
                    onClick: async () => {

                        hud("Please Wait...");

                        let s3Key = "";

                        if (pdfOption === "universal") {
                            s3Key = datasetS3Key;
                        } else {
                            if (file instanceof File) {
                                try {
                                    hud("Uploading file...");
                                    const key = `AgencyRequestForms/${agencyDisplayID}_${file.name}`;
                                    s3Key = await uploadPdf(file, key);
                                } catch (uploadError) {
                                    stopHudRotation();
                                    showAlert(
                                        `Failed to upload ${file.name}. Please try again.`,
                                        [{ label: "OK", color: "var(--buttonColor)", onClick: () => { } }]
                                    );
                                    return;
                                }
                            } else if (file?.s3Key) {
                                s3Key = file.s3Key;
                            }
                        }

                        hud('Please Wait...');

                        let finalObject;
                        try {
                            finalObject = await createAgencyObject(currentJsonString, s3Key);
                        } catch (err) {
                            console.error("Create Agency Object failed:", err);
                            stopHudRotation();
                            showAlert("Invalid form data. Please check all fields.", [
                                { label: "Ok", onClick: () => { }, color: "var(--buttonColor)" }
                            ]);
                            return;
                        }

                        console.log("FINAL OBJECT:", finalObject);

                        try {
                            let response;

                            if (finalObject.id && !isCloneMode) {
                                const payloadWithUser = { ...finalObject, updated_by_email_id: useremail };
                                console.log("update payload", payloadWithUser);
                                response = await agenciesDS.AP_Agency_UPDATE(payloadWithUser);
                            } else {
                                const payloadWithUser = { ...finalObject, created_by_email_id: useremail };
                                console.log("insert payload", payloadWithUser);
                                response = await agenciesDS.AP_Agency_INSERT(payloadWithUser);
                            }

                            const data = response?.data;
                            console.log("error:", data);

                            if (data?.statusCode === 200) {
                                localStorage.removeItem("isClone");
                                localStorage.removeItem("cloneId");
                                localStorage.setItem("selectedDataset", finalObject.datasetID || datasetID);

                                const parsedBody = typeof data.body === "string" ? JSON.parse(data.body) : data.body;
                                const bodyMessage = parsedBody?.message || (finalObject.id ? "Agency updated successfully" : "Agency added successfully");

                                insertLog(
                                    `${userName} ${isCloneMode ? "cloned" : finalObject.id ? "updated" : "added"} agency ${finalObject.agencyName}`,
                                    0, useremail, hud, stopHudRotation, showAlert,
                                    finalObject.id || '',
                                    (finalObject.id && !isCloneMode) ? 'UPDATE' : 'INSERT',
                                    (finalObject.id && !isCloneMode) ? 'AP_Agency_UPDATE' : 'AP_Agency_INSERT',
                                    'SUCCESS', ''
                                );

                                showAlert(bodyMessage, [
                                    { label: "Ok", onClick: () => navigate("/Agencies"), color: "var(--buttonColor)" },
                                ]);
                            } else {
                                const parsedBody = typeof data.body === "string" ? JSON.parse(data.body) : data.body;
                                insertLog(
                                    `${userName} failed to ${isCloneMode ? "clone" : finalObject.id ? "update" : "add"} agency ${finalObject.agencyName}`,
                                    0, useremail, hud, stopHudRotation, showAlert,
                                    finalObject.id || '',
                                    (finalObject.id && !isCloneMode) ? 'UPDATE' : 'INSERT',
                                    (finalObject.id && !isCloneMode) ? 'AP_Agency_UPDATE' : 'AP_Agency_INSERT',
                                    'FAILED',
                                    'An error occurred.'
                                );
                                showAlert(parsedBody?.error, [{ label: "Ok", onClick: () => { }, color: "var(--buttonColor)" }]);
                            }
                        } catch (error) {
                            insertLog(
                                `${userName} failed to ${isCloneMode ? "clone" : finalObject.id ? "update" : "add"} agency ${finalObject.agencyName}`,
                                0, useremail, hud, stopHudRotation, showAlert,
                                finalObject.id || '',
                                (finalObject.id && !isCloneMode) ? 'UPDATE' : 'INSERT',
                                (finalObject.id && !isCloneMode) ? 'AP_Agency_UPDATE' : 'AP_Agency_INSERT',
                                'FAILED',
                                error?.response?.data?.message || error.message || 'An error occurred.'
                            );
                            showAlert(
                                error?.response?.data?.message || error.message || 'An error occurred.',
                                [{ label: 'Ok', onClick: () => { }, color: 'var(--buttonColor)' }]
                            );
                        } finally {
                            stopHudRotation();
                        }
                    },
                    color: "var(--buttonColor)",
                },
            ]
        );
    };


    const normalizeBucketNamePart = (value) => (
        String(value)
            .trim()
            .toLowerCase()
            .replace(/\s+/g, "-")
            .replace(/[^a-z0-9-]/g, "-")
            .replace(/-+/g, "-")
            .replace(/^-+|-+$/g, "")
    );

    const uploadPdf = async (file, key) => {
        const idToken = localStorage.getItem("idToken");

        const dataset = datasets.find(ds => ds.datasetID === datasetID);

        const bucketName = `${normalizeBucketNamePart(datasetID)}-${normalizeBucketNamePart(dataset.datasetName)}-files-${process.env.REACT_APP_ALIAS}`;

        const s3 = new S3Client({
            region: process.env.REACT_APP_AWS_REGION,
            credentials: fromCognitoIdentityPool({
                clientConfig: { region: process.env.REACT_APP_AWS_REGION },
                identityPoolId: process.env.REACT_APP_CONNECT_IDENTITY_POOL_ID,
                logins: {
                    [`cognito-idp.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_COGNITO_USERPOOLID}`]:
                        idToken,
                },
            }),
        });
        const command = new PutObjectCommand({
            Bucket: bucketName,
            Key: key,
            Body: await file.arrayBuffer(),
            ContentType: file.type,
        });

        await s3.send(command);
        return key;
    };

    const handleFileChange = async (e) => {
        const selectedFile = e.target.files?.[0];
        if (!selectedFile) return;
        if (selectedFile.type !== "application/pdf") {
            showToast({
                message: "Only PDF files are allowed"
            });

            e.target.value = "";
            return;
        }
        // set the real File object (so file.type exists)
        setFile(selectedFile);
        setHasExistingFile(false);
        clearFieldError("fileUpload");
        setIsDirty(true);
        const previewUrl = URL.createObjectURL(selectedFile);
        setFilePreview(previewUrl);
    };
    // EDIT Functionality


    const normalizeRequestType = (type) => {
        if (!type) return "";

        type = type.toLowerCase().trim();

        if (type === "fax") return "fax";
        if (type === "email") return "emailReq";
        if (type === "snail mail") return "snail";
        if (type === "drop off") return "dropoff";
        if (type.includes("request on agency website")) return "agenweb";
        if (type.includes("crash")) return "crashdocx";
        return "";
    };

    const normalizeResponseType = (type) => {
        if (!type) return "";

        type = type.toLowerCase().trim();

        if (type.includes("fax")) return "fax";
        if (type.includes("email")) return "email";
        if (type.includes("pick")) return "pickup";
        if (type.includes("snail")) return "snailmail";
        if (type.includes("agency website")) return "agenweb";
        if (type.includes("crash")) return "crashdocs";

        return "";
    };



    const patchFormValues = (record) => {

        hud("Please Wait..")

        setMongoId(record._id);
        setAgencyID(record.agencyID);
        setAgencyName(record.agencyName);
        setDatasetID(record.datasetID);
        setAgencyDisplayID(record.agencyDisplayID);
        setAgencyDisplayName(record.agencyDisplayName);
        setAgencyCountyName(record.agencyCountyName);
        if (Array.isArray(record.agencyPhoneNumbers) && record.agencyPhoneNumbers.length > 0) {
            setAgencyPhoneNumbers(record.agencyPhoneNumbers);
        } else if (record.agencyPhoneNumber) {
            setAgencyPhoneNumbers([{ number: record.agencyPhoneNumber, isPrimary: true }]);
        } else {
            setAgencyPhoneNumbers([{ number: "", isPrimary: false }]);
        }


        setTriggerEvents(
            record.TriggerEvents?.length
                ? record.TriggerEvents.map(t => ({
                    waitDays: t.waitDays ?? "",
                    action: t.action || ""
                }))
                : [{ waitDays: "", action: "" }]
        );

        // Only patch the Counter-specific fields
        setDataSiteUrl(record.dataSiteUrl || "");
        setSeqNo(record.seqNo ?? "");
        setSkipCount(record.skipCount ?? "");
        setHandledByUser(record.handledByUser);
        // setHandledByUserEmail(record.handledByUserEmail);
        setIsActive(record.isActive ?? true);
        setSkipCount(record.consecutiveSkipCount);
        setDocketType(record.docketType ?? "")
        setPriority(record.priority || "");
        const currentYear = new Date().getFullYear().toString();

        setSeqList(
            record.seqDetails?.length ?
                record.seqDetails.map(t => ({
                    year: t.year,
                    seqNo: t.seqNo
                }))
                : [{ year: "", seqNo: "" }]
        )
        stopHudRotation();

        // setAddressName(record.agencyAddress?.name);
        setAddressLine(record.agencyAddress?.address);
        setCity(record.agencyAddress?.city);
        setStateVal(record.agencyAddress?.state);
        setZip(record.agencyAddress?.zip);
        setAgencyContactPerson(record.agencyContactPerson);
        setAgencyDepartment(record.agencyDepartment);
        setHandledBy(record.Handledby);
        setHandledByUser(record.handledByUser);
        setHandledByUserEmail(record.handledByUserEmail);
        setIsActive(record.isActive);
        setSmtpSubject(record.smtpSettings?.subject || "");

        setEmails(
            Array.isArray(record.associatedFromEMails)
                ? record.associatedFromEMails
                : [""]
        );

        const isUniversal = record.pdfForm?.universalForm === true;
        setPdfOption(isUniversal ? "universal" : "custom");

        const acroFields = record.pdfForm?.acroFields || {};
        const acroJson = Object.keys(acroFields).length > 0
            ? JSON.stringify(acroFields, null, 2)
            : "";
        const acroList = Object.entries(acroFields).map(([key, value]) => ({
            key,
            value: String(value),
            _isNew: false
        }));

        setJsonInput(acroJson);
        setAcroFieldsList(acroList);

        if (isUniversal) {
            // Just patch from record — no API call needed
            setDatasetS3Key(record.pdfForm?.s3Key || "");
            setFile(null);
            setHasExistingFile(false);
            setFilePreview(null);

            // Seed universal cache with record's saved acroFields
            universalFormCacheRef.current = {
                jsonInput: acroJson,
                acroFieldsList: acroList
            };

            // Seed globalFormDataRef with record data so switching to Custom
            // and back to Universal restores correctly without any API call
            globalFormDataRef.current = {
                s3Key: record.pdfForm?.s3Key || "",
                acroFields
            };

        } else {
            // Patch custom file from record
            const existingS3Key = record.pdfForm?.s3Key || "";
            if (existingS3Key) {
                const fileName = record.pdfForm?.fileName || existingS3Key.split("/").pop();
                setFile({ name: fileName, s3Key: existingS3Key });
                setHasExistingFile(true);
            } else {
                setFile(null);
                setHasExistingFile(false);
            }
            setFilePreview(null);

            // Seed custom cache with record's data
            customFormCacheRef.current = {
                file: existingS3Key
                    ? { name: record.pdfForm?.fileName || existingS3Key.split("/").pop(), s3Key: existingS3Key }
                    : null,
                filePreview: null,
                jsonInput: acroJson,
                acroFieldsList: acroList
            };

            globalFormDataRef.current = { s3Key: "", acroFields: {} };
        }

        const type = normalizeRequestType(record.requestMethod?.requestType);


        // SNAIL MAIL
        const snail = record.requestMethod?.snailMailSettings;
        // DROP OFF
        const drop = record.requestMethod?.dropoffSettings;
        console.log("faxList", record.requestMethod?.faxSettings);
        // STORE PATCHED VALUES
        setReqMethodValues(prev => ({
            ...prev,
            fax: { faxList: record.requestMethod?.faxSettings },
            emailReq: { emailList: record.requestMethod?.emailSettings },
            snail: {
                snailEmailList: snail?.emailaddress || [""],
                snailName: snail?.address?.name || "",
                snailAddress: snail?.address?.address || "",
                snailCity: snail?.address?.city || "",
                snailState: snail?.address?.state || "",
                snailZip: snail?.address?.zip || "",
            },
            dropoff: {
                dropOffEmails: drop?.emailaddress || [""],
                dropName: drop?.address?.name || "",
                dropAddress: drop?.address?.address || "",
                dropCity: drop?.address?.city || "",
                dropState: drop?.address?.state || "",
                dropZip: drop?.address?.zip || "",
            },
            agenweb: {
                agenEmail: record.requestMethod?.agencyWebsiteSettings?.email || "",
                agenUrl: record.requestMethod?.agencyWebsiteSettings?.websiteURL || "",
                agenDescription: record.requestMethod?.agencyWebsiteSettings?.description || "",
            },
            crashdocx: {
                crashEmail: record.requestMethod?.crashDocsWebsiteSettings?.email || "",
                crashUrl: record.requestMethod?.crashDocsWebsiteSettings?.websiteURL || "",
                crashDescription: record.requestMethod?.crashDocsWebsiteSettings?.description || "",
            }
        }));
        setReqMethod(type);


        const restype = normalizeResponseType(record.responseMethod?.responseType);

        // --- RESPONSE PATCHING ---
        //For snail mail
        const resSnail = record.responseMethod?.snailMailSettings;

        //For pickup
        const resPickup = record.responseMethod?.pickupSettings;

        //For agency website
        const resAgen = record.responseMethod?.agencyWebsiteSettings;

        //For crashdocs
        const resCrash = record.responseMethod?.crashDocsWebsiteSettings;
        // Store response values into responseMethodValues
        // setResponseMethodValues(prev => ({
        //     ...prev,

        //     fax: {
        //         resFaxList: record.responseMethod?.faxSettings || [""]
        //     },

        //     email: {
        //         resEmailList: record.responseMethod?.emailSettings || [""]
        //     },

        //     snailmail: {
        //         resSnailEmailList: resSnail?.emailaddress || [""],
        //         resSnailName: resSnail?.address?.name || "",
        //         resSnailAddress: resSnail?.address?.address || "",
        //         resSnailCity: resSnail?.address?.city || "",
        //         resSnailState: resSnail?.address?.state || "",
        //         resSnailZip: resSnail?.address?.zip || ""
        //     },

        //     pickup: {
        //         resPickupEmails: resPickup?.emailaddress || [""],
        //         resPickupName: resPickup?.address?.name || "",
        //         resPickupAddress: resPickup?.address?.address || "",
        //         resPickupCity: resPickup?.address?.city || "",
        //         resPickupState: resPickup?.address?.state || "",
        //         resPickupZip: resPickup?.address?.zip || ""
        //     },

        //     agenweb: {
        //         resAgenEmail: resAgen?.email || "",
        //         resAgenUrl: resAgen?.websiteURL || "",
        //         resAgenDescription: resAgen?.description || ""
        //     },

        //     crashdocs: {
        //         resCrashEmail: resCrash?.email || "",
        //         resCrashUrl: resCrash?.websiteURL || "",
        //         resCrashDescription: resCrash?.description || ""
        //     }
        // }));

        setResponseMethod(restype);
        const freq = record.frequency || {};

        setFrequencyType(freq.frequencyType || "");
        setTime(freq.frequencySettings?.time || "00");

        const wk = freq.frequencySettings?.weekDays || [];
        const md = freq.frequencySettings?.monthDays || [];

        // Store patched values separately
        if (freq.frequencyType === "Weekly") setPatchedWeekly(wk);
        if (freq.frequencyType === "OddWeekly") setPatchedOddWeekly(wk);
        if (freq.frequencyType === "EvenWeekly") setPatchedEvenWeekly(wk);
        if (freq.frequencyType === "Monthly") setPatchedMonthDays(md);

        setSelectedWeekDays(wk);
        setSelectedMonthDays(md);

        setTriggerEvents(
            record.TriggerEvents?.length
                ? record.TriggerEvents.map(t => ({
                    waitDays: t.waitDays ?? "",
                    action: t.action || ""
                }))
                : [{ waitDays: "", action: "" }]
        );

        const range = record.reqRange || {};
        setDateRange({
            from: range.offsetBegins ?? '',
            to: range.offsetEnds ?? ''
        });
        setWaitDaysBeforeSendingEmail(
            record.callAndMailSettings?.waitDaysBeforeSendingAnotherEmail ?? ""
        );
        setWaitDaysBeforeCallingAgain(
            record.callAndMailSettings?.waitDaysBeforeCallingAgain ?? ""
        );
        stopHudRotation();
    };

    const clearFieldError = (fieldName) => {
        setErrors((prev) => ({ ...prev, [fieldName]: "" }));
    };


    const isBase64Image = (str) => {
        if (!str || str.trim() === "") return false;
        // Base64 PNG usually starts with iVBORw0
        return str.startsWith("iVBORw0");
    };

    // Convert text to base64 image
    // const textToBase64Image = (text) => {
    //     const canvas = document.createElement("canvas");
    //     const ctx = canvas.getContext("2d");

    //     ctx.font = "20px Arial";
    //     const textWidth = ctx.measureText(text).width;

    //     canvas.width = textWidth + 20;
    //     canvas.height = 40;

    //     ctx.font = "20px Arial";
    //     ctx.fillStyle = "black";
    //     ctx.fillText(text, 10, 25);

    //     return canvas.toDataURL("image/png").replace("data:image/png;base64,", "");
    // };


    const uploadSignatureBlob = async (blob, fieldKey) => {
        const idToken = localStorage.getItem("idToken");

        const dataset = datasets.find(ds => ds.datasetID === datasetID);

        const bucketName = `${normalizeBucketNamePart(datasetID)}-${normalizeBucketNamePart(dataset.datasetName)}-files-${process.env.REACT_APP_ALIAS}`;

        const s3 = new S3Client({
            region: process.env.REACT_APP_AWS_REGION,
            credentials: fromCognitoIdentityPool({
                clientConfig: { region: process.env.REACT_APP_AWS_REGION },
                identityPoolId: process.env.REACT_APP_CONNECT_IDENTITY_POOL_ID,
                logins: {
                    [`cognito-idp.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_COGNITO_USERPOOLID}`]:
                        idToken,
                },
            }),
        });

        const fileName = `${agencyDisplayID}.png`;
        const key = `Signatures/${fileName}`;

        const command = new PutObjectCommand({
            Bucket: bucketName,
            Key: key,
            Body: await blob.arrayBuffer(),  // ✅ Blob has arrayBuffer()
            ContentType: "image/png",
        });

        await s3.send(command);
        return key;
    };

    const textToSignatureBlob = (text) => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        ctx.font = "20px Arial";
        const textWidth = ctx.measureText(text).width;
        canvas.width = textWidth + 20;
        canvas.height = 40;
        ctx.font = "20px Arial";
        ctx.fillStyle = "black";
        ctx.fillText(text, 10, 25);

        return new Promise((resolve) => {
            canvas.toBlob((blob) => resolve(blob), "image/png");
        });
    };

    // Process acroFields JSON
    const processAcroFields = async (rawObject) => {
        const obj = JSON.parse(JSON.stringify(rawObject));

        let firstName = "";
        let lastName = "";

        Object.keys(obj).forEach((key) => {
            const lowerKey = key.toLowerCase();
            if (lowerKey.includes("firstname")) firstName = obj[key];
            if (lowerKey.includes("lastname")) lastName = obj[key];
        });

        console.log("Detected firstname:", firstName, "lastname:", lastName);

        for (const key of Object.keys(obj)) {
            const lowerKey = key.toLowerCase();
            let value = obj[key];



            if (lowerKey.endsWith("_signature")) {

                if (typeof value !== "string") continue;

                if (value.trim().startsWith("Signatures/") ||
                    value.trim().startsWith("signatures/")
                ) {
                    console.log(`Signature '${key}' already S3 key → skipping.`);
                    continue;
                }

                let blob = null;

                // 1. Has text and NOT base64 → convert
                if (value && value.trim() !== "" && !isBase64Image(value)) {
                    blob = await textToSignatureBlob(value);
                    console.log(`Signature '${key}' → text converted to base64.`);
                }
                // 2. Empty → use firstname + lastname
                else if (!value || value.trim() === "") {
                    const fullName = `${firstName} ${lastName}`;
                    blob = await textToSignatureBlob(fullName);
                    console.log(`Signature '${key}' empty → using firstname_lastname → converted.`);
                }
                // 3. Already base64 → upload as-is
                else if (isBase64Image(value)) {
                    const byteCharacters = atob(value);
                    const byteArray = new Uint8Array(byteCharacters.length).map((_, i) => byteCharacters.charCodeAt(i));
                    blob = new Blob([byteArray], { type: "image/png" });
                    console.log(`Signature '${key}' already base64 → converted to Blob.`);
                }

                if (blob) {
                    try {
                        const s3Key = await uploadSignatureBlob(blob, key);
                        obj[key] = s3Key;
                        console.log(`Signature '${key}' uploaded to S3 → key: ${s3Key}`);
                    } catch (err) {
                        throw new Error(`Signature upload failed for field: ${key}`);
                    }
                }
            }
        }

        return obj;
    };


    const handleFrequencyChange = (type) => {
        if (type === frequencyType) return;

        setFrequencyType(type);
        markDirty();


        if (type === "Weekly") {
            setSelectedWeekDays(patchedWeekly);
        }
        else if (type === "OddWeekly") {
            setSelectedWeekDays(patchedOddWeekly);
        }
        else if (type === "EvenWeekly") {
            setSelectedWeekDays(patchedEvenWeekly);
        }
        else if (type === "Monthly") {
            setSelectedMonthDays(patchedMonthDays);
        }
    };


    const confirmNavigation = (path) => {
        if (!isDirty) {
            navigate(path);
            return;
        }

        showAlert("You have unsaved changes. Are you sure you want to leave?", [
            { label: "Cancel" },
            {
                label: "Leave",
                onClick: () => {
                    setIsDirty(false);
                    navigate(path);
                },
            },
        ]);
    };
    const addPhoneNumber = () => {
        setAgencyPhoneNumbers(prev => [...prev, { number: "", isPrimary: false }]);
        markDirty();
    };

    const updatePhoneNumber = (index, value) => {
        setAgencyPhoneNumbers(prev => {
            const updated = [...prev];
            updated[index] = { ...updated[index], number: value };
            return updated;
        });
        clearFieldError("duplicatePhone");
        markDirty();
    };

    const setPrimaryPhone = (index) => {
        setAgencyPhoneNumbers(prev =>
            prev.map((phone, i) => ({ ...phone, isPrimary: i === index }))
        );
        markDirty();
    };


    const generatePresignedUrl = async () => {

        if (!file?.s3Key) {
            showAlert("No file available to preview.", [
                { label: "OK", color: "var(--buttonColor)", onClick: () => { } }
            ]);
            return;
        }
        const dataset = datasets.find(ds => ds.datasetID === datasetID);

        try {
            hud("Generating preview...");

            const idToken = localStorage.getItem("idToken");

            const bucketName = `${normalizeBucketNamePart(datasetID)}-${normalizeBucketNamePart(dataset.datasetName)}-files-${process.env.REACT_APP_ALIAS}`;

            const s3 = new S3Client({
                region: process.env.REACT_APP_AWS_REGION,
                credentials: fromCognitoIdentityPool({
                    clientConfig: { region: process.env.REACT_APP_AWS_REGION },
                    identityPoolId: process.env.REACT_APP_CONNECT_IDENTITY_POOL_ID,
                    logins: {
                        [`cognito-idp.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_COGNITO_USERPOOLID}`]:
                            idToken,
                    },
                }),
            });

            const { getSignedUrl } = await import("@aws-sdk/s3-request-presigner");
            const { GetObjectCommand } = await import("@aws-sdk/client-s3");

            const command = new GetObjectCommand({
                Bucket: bucketName,
                Key: file.s3Key,
            });

            const signedUrl = await getSignedUrl(s3, command, { expiresIn: 300 }); // 5 min
            window.open(signedUrl, "_blank");

        } catch (err) {
            console.error("Presigned URL error:", err);
            showAlert("Failed to generate preview. Please try again.", [
                { label: "OK", color: "var(--buttonColor)", onClick: () => { } }
            ]);
        } finally {
            stopHudRotation();
        }
    };


    const generateUniversalPdfUrlOrSignature = async (s3Key) => {
        if (!s3Key) {
            showAlert("No file available to preview.", [
                { label: "OK", color: "var(--buttonColor)", onClick: () => { } }
            ]);
            return;
        }

        const dataset = datasets.find(ds => ds.datasetID === datasetID);

        try {
            hud("Generating preview...");

            const idToken = localStorage.getItem("idToken");

            const bucketName = `${normalizeBucketNamePart(datasetID)}-${normalizeBucketNamePart(dataset.datasetName)}-files-${process.env.REACT_APP_ALIAS}`;

            const s3 = new S3Client({
                region: process.env.REACT_APP_AWS_REGION,
                credentials: fromCognitoIdentityPool({
                    clientConfig: { region: process.env.REACT_APP_AWS_REGION },
                    identityPoolId: process.env.REACT_APP_CONNECT_IDENTITY_POOL_ID,
                    logins: {
                        [`cognito-idp.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_COGNITO_USERPOOLID}`]:
                            idToken,
                    },
                }),
            });

            const { getSignedUrl } = await import("@aws-sdk/s3-request-presigner");
            const { GetObjectCommand } = await import("@aws-sdk/client-s3");

            const command = new GetObjectCommand({
                Bucket: bucketName,
                Key: s3Key,
            });

            const signedUrl = await getSignedUrl(s3, command, { expiresIn: 300 }); // 5 min

            window.open(signedUrl, "_blank");

        } catch (err) {
            console.error("Universal PDF presigned URL error:", err);

            showAlert("Failed to generate Universal PDF preview. Please try again.", [
                { label: "OK", color: "var(--buttonColor)", onClick: () => { } }
            ]);

        } finally {
            stopHudRotation();
        }
    };


    const handleOpenFileSection = async () => {
        const isOpening = !openSection.includes("fileSection");

        setOpenSection(prev =>
            prev.includes("fileSection")
                ? prev.filter(s => s !== "fileSection")
                : [...prev, "fileSection"]
        );

        if (isOpening && !mongoId && !globalFormDataRef.current.s3Key) {
            await fetchdatasetS3Key();
        }
    };


    const fetchdatasetS3Key = async () => {
        hud("Please Wait...");
        try {
            const response = await agenciesDS.WS_s3Key_By_Dataset_GET(
                {
                    datasetID: datasetID
                });

            const data = response.data;

            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;

            if (data.statusCode === 200 && body) {

                const pdf = body?.pdfForm || {};

                const s3Key = pdf.s3Key || body?.s3Key || "";

                const acroFields = pdf.acroFields || {};

                globalFormDataRef.current = { s3Key, acroFields };


                setDatasetS3Key(s3Key);
                if (Object.keys(acroFields).length > 0) {

                    setJsonInput(JSON.stringify(acroFields, null, 2));

                    const listData = Object.entries(acroFields).map(([key, value]) => ({
                        key,
                        value: String(value),
                        _isNew: false
                    }));

                    setAcroFieldsList(listData);

                } else {
                    setJsonInput("");
                    setAcroFieldsList([]);
                }

                if (!mongoId) {
                    setPdfOption(prev => prev || (s3Key ? "universal" : "custom"));
                }

            } else {
                showAlert(
                    body.message || "Failed to Fetch.",
                    [
                        {
                            label: "OK",
                            onClick: () => { },
                            color: "var(--buttonColor)"
                        }
                    ]
                );
                insertLog(
                    `${userName} failed to fetch dataset S3 key for dataset ${datasetID}`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    datasetID || '',
                    'GET',
                    'WS_s3Key_By_Dataset_GET',
                    'FAILED',
                    'Failed to fetch dataset PDF configuration'
                );
            }

        } catch (err) {
            showAlert(
                err.message || "Failed to Fetch.",
                [
                    {
                        label: "OK",
                        onClick: () => { },
                        color: "var(--buttonColor)"
                    }
                ]
            );

            insertLog(
                `${userName} failed to fetch dataset S3 key for dataset ${datasetID}`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                datasetID || '',
                'GET',
                'WS_s3Key_By_Dataset_GET',
                'FAILED',
                'Error fetching dataset PDF configuration'
            );


        } finally {

            stopHudRotation();
        }
    }


    return {
        // expose all states + functions to UI
        openSection, setOpenSection,
        file, setFile,
        jsonInput, jsonError,
        errors,
        mongoId,
        agencyID, setAgencyID,
        agencyName, setAgencyName,
        datasetID, setDatasetID,
        agencyDisplayID, setAgencyDisplayID,
        agencyDisplayName, setAgencyDisplayName,
        agencyCountyName, setAgencyCountyName,
        agencyPhoneNumbers, setAgencyPhoneNumbers,
        addPhoneNumber, updatePhoneNumber, setPrimaryPhone,
        agencyContactPerson, setAgencyContactPerson,
        agencyDepartment, setAgencyDepartment,
        handledBy, setHandledBy, setHandledByUser, handledByUser, handledByUserEmail, setHandledByUserEmail, isActive, setIsActive,

        // addressName, setAddressName,
        addressLine, setAddressLine,
        city, setCity,
        stateVal, setStateVal,
        zip, setZip,

        smtpSubject, setSmtpSubject,

        emails,
        addEmail,
        removeEmail,
        updateEmail,

        toggleSection,
        handleBack,
        handleJsonInput,
        handleClearFile,
        handleFinalSave,
        // Request Method
        reqMethod,
        setReqMethod,
        handleReqMethodChange,

        // Errors
        errors,
        setErrors,

        // Fax
        faxList,
        setFaxList,
        addFax,
        removeFax,

        // Email
        emailList,
        setEmailList,
        emailRemove,

        // Snail Mail
        snailEmailList,
        setSnailEmailList,
        addSnailEmail,
        removeSnailEmail,
        snailName,
        setSnailName,
        snailAddress,
        setSnailAddress,
        snailCity,
        setSnailCity,
        snailState,
        setSnailState,
        snailZip,
        setSnailZip,
        addEmailReq,

        // Drop Off
        dropOffEmails,
        setDropOffEmails,
        addDropoffEmail,
        removeDropoffEmail,
        dropName,
        setDropName,
        dropAddress,
        setDropAddress,
        dropCity,
        setDropCity,
        dropState,
        setDropState,
        dropZip,
        setDropZip,

        // Agency Website + CrashDocs
        agenEmail,
        setAgenEmail,
        agenUrl,
        setAgenUrl,
        agenDescription,
        setAgenDescription,
        crashEmail,
        setcrashEmail,
        crashUrl,
        setcrashUrl,
        crashDescription,
        setcrashDescription,


        // Response Method
        responseMethod,
        setResponseMethod,

        // Trigger Events
        triggerEvents,
        setTriggerEvents,

        // Frequency
        frequencyType,
        setFrequencyType,
        selectedWeekDays,
        setSelectedWeekDays,
        selectedMonthDays,
        setSelectedMonthDays,
        showMonthDropdown,
        setShowMonthDropdown,
        weekdays,
        monthDays,
        toggleWeekDay,
        toggleMonthDay,
        time,
        setTime,

        // Date Range
        dateRange,
        setDateRange,
        datasets,
        handleFileChange,
        filePreview,
        clearFieldError,
        handleFrequencyChange,
        // snailEmailErrors,
        // setSnailEmailErrors,
        // dropoffEmailErrors,
        // setDropoffEmailErrors,
        // faxErrors,
        // setFaxErros,
        // emailReqErrors,
        // setEmailReqErrors
        acroFieldsTab,
        setAcroFieldsTab,
        acroFieldsList,
        setAcroFieldsList,
        syncAcroListToJson,
        syncAcroJsonToList,
        handleDeleteAcroField,
        handleResMethodChange, resEmailList, setResEmailList, resSnailName, setResSnailName, resSnailEmailList,
        setResSnailEmailList, resFaxList, setResFaxList,
        resSnailAddress, setResSnailAddress, resSnailCity,
        setResSnailCity, resSnailState,
        setResSnailState, resSnailZip, setResSnailZip,
        resPickupEmails, setResPickupEmails, resPickupName, setResPickupName,
        resPickupAddress, setResPickupAddress, resPickupCity, setResPickupCity,
        resPickupState, setResPickupState, resPickupZip, setResPickupZip, resAgenEmail,
        setResAgenEmail,
        resAgenUrl, setResAgenUrl, resAgenDescription, setResAgenDescription,
        resCrashEmail, setResCrashEmail, resCrashUrl, setResCrashUrl,
        resCrashDescription, setResCrashDescription, removeResFax, addResFax, removeResEmail, addResEmail, removeResSnailEmail, addResSnailEmail,
        addResPickupEmail, removeResPickupEmail, markDirty, selectedDataset, setSelectedDataset, entryType, docketType, setDocketType, dataSiteUrl, setDataSiteUrl, seqNo, setSeqNo
        , skipCount, setSkipCount, seqList, setSeqList, updateSeq, removeSeq, addSeq, isCounterBased, isDateRangeBased, isRequestBased, priority,
        setPriority, waitDaysBeforeSendingEmail, setWaitDaysBeforeSendingEmail, waitDaysBeforeCallingAgain, setWaitDaysBeforeCallingAgain, isCloneMode, generatePresignedUrl, handleOpenFileSection
        , datasetS3Key, generateUniversalPdfUrlOrSignature, pdfOption, setPdfOption, setFilePreview, setHasExistingFile, setIsDirty, agencie, fetchdatasetS3Key, handleCustomPdfClick, handleUniversalPdfClick,
        isJsonEditable, setIsJsonEditable
    };
};

export default AddAgencyLogic;
